// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__1JmIK","header":"ClearentDisclaimer_header__2rGDJ","inner":"ClearentDisclaimer_inner__3j-7h"};